// 更新全局loading
const UPDATEGLOBALLOAD = 'UPDATEGLOBALLOAD';

export default UPDATEGLOBALLOAD;
